<script>
export default {
  name: 'FiltroPositivoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original colide quando o ícone renderiza mais de uma vez na página.
    maskId() {
      return `mask0_5584_146872_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icone filtro positivo">
      <path
        id="Mask"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 7.00012H4.185C4.599 8.16112 5.698 9.00012 7 9.00012C8.302 9.00012 9.401 8.16112 9.815 7.00012H21C21.553 7.00012 22 6.55312 22 6.00012C22 5.44712 21.553 5.00012 21 5.00012H9.815C9.401 3.83912 8.302 3.00012 7 3.00012C5.698 3.00012 4.599 3.83912 4.185 5.00012H3C2.447 5.00012 2 5.44712 2 6.00012C2 6.55312 2.447 7.00012 3 7.00012ZM19 9.00012C17.698 9.00012 16.599 9.83912 16.185 11.0001H3C2.447 11.0001 2 11.4471 2 12.0001C2 12.5531 2.447 13.0001 3 13.0001H16.185C16.599 14.1611 17.698 15.0001 19 15.0001C20.654 15.0001 22 13.6541 22 12.0001C22 10.3461 20.654 9.00012 19 9.00012ZM13.815 17.0001H21C21.553 17.0001 22 17.4471 22 18.0001C22 18.5531 21.553 19.0001 21 19.0001H13.815C13.401 20.1611 12.302 21.0001 11 21.0001C9.698 21.0001 8.599 20.1611 8.185 19.0001H3C2.447 19.0001 2 18.5531 2 18.0001C2 17.4471 2.447 17.0001 3 17.0001H8.185C8.599 15.8391 9.698 15.0001 11 15.0001C12.302 15.0001 13.401 15.8391 13.815 17.0001Z"
        :fill="color"
      />
      <mask
        :id="maskId"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="2"
        y="3"
        width="20"
        height="19"
      >
        <path
          id="Mask_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 7.00012H4.185C4.599 8.16112 5.698 9.00012 7 9.00012C8.302 9.00012 9.401 8.16112 9.815 7.00012H21C21.553 7.00012 22 6.55312 22 6.00012C22 5.44712 21.553 5.00012 21 5.00012H9.815C9.401 3.83912 8.302 3.00012 7 3.00012C5.698 3.00012 4.599 3.83912 4.185 5.00012H3C2.447 5.00012 2 5.44712 2 6.00012C2 6.55312 2.447 7.00012 3 7.00012ZM19 9.00012C17.698 9.00012 16.599 9.83912 16.185 11.0001H3C2.447 11.0001 2 11.4471 2 12.0001C2 12.5531 2.447 13.0001 3 13.0001H16.185C16.599 14.1611 17.698 15.0001 19 15.0001C20.654 15.0001 22 13.6541 22 12.0001C22 10.3461 20.654 9.00012 19 9.00012ZM13.815 17.0001H21C21.553 17.0001 22 17.4471 22 18.0001C22 18.5531 21.553 19.0001 21 19.0001H13.815C13.401 20.1611 12.302 21.0001 11 21.0001C9.698 21.0001 8.599 20.1611 8.185 19.0001H3C2.447 19.0001 2 18.5531 2 18.0001C2 17.4471 2.447 17.0001 3 17.0001H8.185C8.599 15.8391 9.698 15.0001 11 15.0001C12.302 15.0001 13.401 15.8391 13.815 17.0001Z"
          fill="white"
        />
      </mask>
      <g :mask="`url(#${maskId})`">
        <g id="🎨 Color">
          <rect id="Base" width="24" height="24" :fill="color" />
        </g>
      </g>
    </g>
  </svg>
</template>
